import { $ } from './dom.js';
import { onLenisScroll } from './lenis-scroll.js';

const FINE_POINTER_MQ = '(hover: hover) and (pointer: fine)';

export function setupCustomCursor(root, cursorSelector) {
  const cursor = $(cursorSelector, root);
  const finePointer = window.matchMedia(FINE_POINTER_MQ);

  if (!cursor || !finePointer.matches) {
    return () => {};
  }

  root.classList.add('has-custom-cursor');

  let lastX = null;
  let lastY = null;

  const hideCursor = () => {
    cursor.classList.remove('is-visible', 'is-prev');
  };

  const syncCursorAtPoint = (x, y) => {
    const target = document.elementFromPoint(x, y);

    if (!target || !root.contains(target)) {
      hideCursor();
      return;
    }

    cursor.classList.add('is-visible');
    cursor.style.left = `${x}px`;
    cursor.style.top = `${y}px`;

    const bounds = root.getBoundingClientRect();
    const isPrev = x < bounds.left + bounds.width / 2;
    cursor.classList.toggle('is-prev', isPrev);
  };

  const onPointerEnter = (event) => {
    lastX = event.clientX;
    lastY = event.clientY;
    syncCursorAtPoint(lastX, lastY);
  };

  const onPointerLeave = () => {
    lastX = null;
    lastY = null;
    hideCursor();
  };

  const onPointerMove = (event) => {
    lastX = event.clientX;
    lastY = event.clientY;
    syncCursorAtPoint(lastX, lastY);
  };

  const onScroll = () => {
    if (lastX == null || lastY == null) {
      return;
    }

    syncCursorAtPoint(lastX, lastY);
  };

  const onPointerChange = () => {
    if (!finePointer.matches) {
      root.classList.remove('has-custom-cursor');
      hideCursor();
    } else {
      root.classList.add('has-custom-cursor');
    }
  };

  root.addEventListener('pointerenter', onPointerEnter);
  root.addEventListener('pointerleave', onPointerLeave);
  root.addEventListener('pointermove', onPointerMove);
  finePointer.addEventListener('change', onPointerChange);

  const removeLenisListener = onLenisScroll(onScroll);
  window.addEventListener('scroll', onScroll, { passive: true });

  return () => {
    root.classList.remove('has-custom-cursor');
    hideCursor();
    cursor.style.left = '';
    cursor.style.top = '';
    root.removeEventListener('pointerenter', onPointerEnter);
    root.removeEventListener('pointerleave', onPointerLeave);
    root.removeEventListener('pointermove', onPointerMove);
    finePointer.removeEventListener('change', onPointerChange);
    removeLenisListener();
    window.removeEventListener('scroll', onScroll);
  };
}
